export const ForgotPasswordLink = () => {
  const forgotHref = '/platform/auth/forgot-password';

  return (
    <a className='text-brand-100 text-center underline' href={forgotHref}>
      Forgot password?
    </a>
  );
};
